module.exports = __webpack_public_path__ + "img/headphones.e3f2c527.svg";